import type { TenantUsageTypeLabelKeys } from 'ComponentLibrary/src/common/tenant'
import type { ValueCheckMarketDataLandWidgetCopy } from 'ComponentLibrary/src/widgets/ValueCheckWidgets/ValueCheckMarketDataLandWidget'
import type { ValueCheckMarketDataWidgetCopy } from 'ComponentLibrary/src/widgets/ValueCheckWidgets/ValueCheckMarketDataWidget'
import type { TFunction } from 'i18next'

const tenantUsageTypeKeys = [
    'residential',
    'commercial',
    'gastronomy',
    'industry',
    'hotel',
    'storage',
    'underground_parking',
    'leisure',
    'social',
    'archive',
    'outdoor_parking',
    'parking',
    'retail',
    'logistics',
    'office',
    'other',
    'total',
    'other_parking',
    'open_space',
    'other_use',
    'garage_parking',
] as const satisfies TenantUsageTypeLabelKeys[]

const getTenantUsageTypeLabels = (tCommon: TFunction): Record<TenantUsageTypeLabelKeys, string> =>
    Object.fromEntries(tenantUsageTypeKeys.map((key) => [key, tCommon(`tenantUsageTypes.${key}`)])) as Record<
        TenantUsageTypeLabelKeys,
        string
    >

export const getValueCheckMarketDataWidgetCopy = (
    tCommon: TFunction,
    tValueCheckMarketDataWidget: TFunction
): ValueCheckMarketDataWidgetCopy => ({
    title: tCommon('marketData'),
    sectionLabels: {
        multiplier: tCommon('multiplier'),
        rents: tValueCheckMarketDataWidget('existingRents'),
    },
    rowLabels: {
        minimum: tCommon('minimum'),
        average: tCommon('average'),
        maximum: tCommon('maximum'),
    },
    columnLabels: {
        previousValuation: tCommon('previousValuation'),
        valueCheck: tCommon('valueCheck'),
        change: tCommon('change'),
    },
    usageTypeLabels: getTenantUsageTypeLabels(tCommon),
})

export const getValueCheckLandMarketDataWidgetCopy = (
    tCommon: TFunction,
    tValueCheckLandMarketDataWidget: TFunction
): ValueCheckMarketDataLandWidgetCopy => ({
    title: tValueCheckLandMarketDataWidget('title'),
    rowLabels: {
        minimum: tCommon('minimum'),
        average: tCommon('average'),
        maximum: tCommon('maximum'),
    },
    columnLabels: {
        previousValuation: tCommon('previousValuation'),
    },
})
